import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [],
  template: `
    <div class="text-center py-16">
      <div class="animate-spin border-4 border-light-primary dark:border-dark-primary border-t-transparent dark:border-t-transparent rounded-full mx-auto mb-4"
           [style.width.px]="size" [style.height.px]="size"></div>
      <p class="normal">{{ message }}</p>
    </div>
  `,
})
export class LoadingSpinnerComponent {
  @Input() message: string = 'Cargando...';
  @Input() size: number = 48;
}
